// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import React, {useCallback, useMemo} from 'react';
import cn from 'classnames';
import {list as country_list} from '/util/country.js';
import {Text} from '../text';
import {Select} from '../select.js';
import {Country} from './country.js';
import * as cns from './selector.module.less';

const EXCLUDE = {uk: 1, eu: 1};
export const ALL_ITEM = {label: 'All countries', value: 'all'};

const OPTIONS = Object.keys(country_list).map(key=>({
    label: `${key} - ${country_list[key]}`,
    value: key.toLowerCase(),
})).filter(opt=>!EXCLUDE[opt.value]);

const render = (opt, className)=>{
    const classes = cn(className);
    if (opt.value==ALL_ITEM.value)
        return <Text.xxs className={classes}>{opt.label}</Text.xxs>;
    return <Country className={classes} code={opt.value} size="xxs"
      show_code/>;
};

const render_option = opt=>render(opt, cns.cn_opt);
const render_value = opt=>render(opt, cns.cn_val);

export function Selector({
    value,
    auto_focus,
    on_change,
    disabled,
    className,
    select_classname,
    clearable=true,
    use_all_option,
})
{
    const handle_change = useCallback(option=>
        on_change?.(option?.value), [on_change]);
    const items = useMemo(()=>{
        const res = [...OPTIONS];
        if (use_all_option)
            res.unshift(ALL_ITEM);
        return res;
    }, [use_all_option]);
    return <div className={cn(className)}>
      <Select className={select_classname} disabled={disabled} value={value}
        options={items} on_change={handle_change}
        render_option={render_option} render_value={render_value}
        clearable={clearable} auto_focus={auto_focus}/>
    </div>;
}
